const useTranslation = (translations) => {
  return {
    t: (key, options = {}) => Object.entries(options).reduce(
      (s, [propName, propValue]) => s.replace(`{{${propName}}}`, propValue),
      translations[key]
    )
  };
};
export {
  useTranslation as default
};
//# sourceMappingURL=useTranslation.es.js.map
